/** Returnerer angitt map som et objekt med de samme nøkler og verdier som angitt map. */
export function mapSomObjekt<V>(map: Map<string, V>): { [nøkkel: string]: V } {
    return [...map].reduce((objekt, [nøkkel, verdi]) => {
        objekt[nøkkel] = verdi;
        return objekt;
    }, {} as { [nøkkel: string]: V })
}

/** Returnerer en kopi av angitt map der alle verdier er transformert med angitt mapFunksjon */
export function mapVerdierIMap<N, V, R>(map: Map<N, V>, mapFunksjon: (verdi: V, nøkkel: N) => R): Map<N, R> {
    return [...map].reduce((nyMap, [nøkkel, verdi]) =>
        nyMap.set(nøkkel, mapFunksjon(verdi, nøkkel)),
      new Map<N, R>());
}

/** Legger angitt verdi til listen over verdier knyttet til angitt nøkkel i angitt map.
 * Kan brukes for å implementere gruppering av objekter i en liste på et gitt felt:
 * `[...].reduce((grupper, innslag) => leggTilIListeIMap(grupper, innslag.nøkkelfelt, innslag), new Map<nøkkeltype, innslagtype>())` */
export function leggTilIListeIMap<N,V>(map:Map<N,V[]>, nøkkel:N, verdi:V):Map<N,V[]>{
    if (!map.has(nøkkel)) map.set(nøkkel, []);
    map.get(nøkkel)!.push(verdi);
    return map;
}

/** Funksjon for å gruppere objekter i en liste etter verdien returner av angitt nøkkelFn.
 * Eksempel:
 * `[...].reduce(grupperFunksjon(innslag => innslag.nøkkelfelt), new Map<nøkkeltype, innslagtype>())`*/
export function grupperFunksjon<N,V>(nøkkelFn:(verdi:V)=>N):(map:Map<N,V[]> , innslag:V)=>Map<N,V[]>{
 return (map , verdi) => {
     const nøkkel = nøkkelFn(verdi);
        if (!map.has(nøkkel)) map.set(nøkkel, []);
        map.get(nøkkel)!.push(verdi);
        return map;
    }
}
